import React, { Component } from "react";
import { Modal } from 'react-bootstrap';
import Login from "../components/Login";

class ReLogin extends Component {
    render() {
        return (
            <div>
                <Modal
                    size="xl"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered 
                    show={this.props.show}
                    backdrop="static"
                    keyboard={false}
                    onHide={() => this.props.onHide({ msg: 'Icon Clicked!' })
                }>
                    <Modal.Header closeButton>
                        <Modal.Title className="ms-auto">
                            {this.props.title}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body>

                        <Login reLogin={this.props.reLogin}/>
                    
                    </Modal.Body>
                </Modal>
            </div>
        )
    };
}

export default ReLogin;